// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useState} from 'react';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {get_img_url} from './utils';
import {build_support_link} from '../support_report';
import styles from './bounty_cta.module.less';

const default_background_src = 'bg_bounty_final.png';

export interface i_bounty_cta_props {
  title?: string;
  description?: string;
  cta_text?: string;
  background_src?: string;
}

export const Bounty_cta = ({
  title,
  description,
  cta_text,
  background_src,
}: i_bounty_cta_props)=>{
  return <section className={styles.bounty_cta}>
    <img
      className={styles.bounty_cta__background}
      src={get_img_url(background_src||default_background_src)}
      alt=""
      aria-hidden="true"
    />
    <div className={styles.bounty_cta__inner}>
      {title&&<h2 className={styles.bounty_cta__title}>
        {title}
      </h2>}
      {description&&<p className={styles.bounty_cta__description}>
        {description}
      </p>}
      {cta_text&&<Button
        caption={cta_text}
        to={build_support_link()}
        cls={styles.bounty_cta__button}
        round
      />}
    </div>
  </section>;
};

interface i_bounty_cta_editor_props {
  value: i_bounty_cta_props;
  on_change: (value: i_bounty_cta_props)=>void;
  on_cancel?: ()=>void;
}

export const Bounty_cta_editor = (
  props: i_bounty_cta_editor_props
)=>{
  const [state, set_state] = useState<i_bounty_cta_props>(
    props.value||{}
  );
  return <Editor<i_bounty_cta_props>
    value={state}
    editors={[
      {key: 'title', label: 'Title', type: 'text'},
      {key: 'description', label: 'Description', type: 'textarea'},
      {key: 'cta_text', label: 'CTA text', type: 'text'},
      {
        key: 'background_src',
        label: 'Background image',
        type: 'text',
      },
    ]}
    on_change={set_state}
    on_save={()=>props.on_change(state)}
    on_cancel={props.on_cancel}
  />;
};
